export const SOCIAL_LINKEDIN_PREFIX =
  import.meta.env.VITE_SOCIAL_LINKEDIN_PREFIX ||
  'https://www.linkedin.com/company';
export const SOCIAL_FACEBOOK_PREFIX =
  import.meta.env.VITE_SOCIAL_FACEBOOK_PREFIX || 'https://www.facebook.com';
export const SOCIAL_TWEETER_PREFIX =
  import.meta.env.VITE_SOCIAL_TWEETER_PREFIX || 'https://twitter.com';
export const SOCIAL_INSTAGRAM_PREFIX =
  import.meta.env.VITE_SOCIAL_INSTAGRAM_PREFIX || 'https://instagram.com';
export const CALENDLY_CONTACT_URL = 'https://calendly.com/hamiedelias';
export const BOOK_A_DEMO_URL = 'https://ai-ark.com/book-a-demo';
